import styled from "styled-components";

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
  }
`;

export const MobileCard = styled.div`
  background-color: ${({ theme }) => theme.cardTransparent};
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  .MobileTitle {
    font-size: 24px;
    font-weight: bold;
    color: ${({ theme }) => theme.text};
    padding: 10px;
    margin-bottom: 12px;
    word-spacing: 2px;
  }

  .MobileImage {
    height: 160px;
    margin-bottom: 12px;
    overflow: hidden;
    border-radius: 12px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      object-fit: cover;
    }
  }

  .MobileDescription {
    font-size: 18px;
    padding: 8px 0;
    color: ${({ theme }) => theme.text};
    margin-bottom: 8px;
    font-weight: 600;
    word-spacing: 3px;
  }

  .MobileOverlayTitle {
    font-size: 16px;
    padding: 5px 0;
    color: ${({ theme }) => theme.text};
    font-weight: 550;
    word-spacing: 2px;
  }

  .MobileOverlaySubtitle {
    font-size: 12px;
    padding: 5px 0;
    color: ${({ theme }) => theme.text};
    font-weight: 500;
    word-spacing: 2px;
  }
`;
